import { useEffect } from 'react';

/** Délai max avant affichage footer + prestations + prerenderReady (fiche /pro). */
export const PRO_PUBLIC_REVEAL_MAX_MS = 3000;

export function useProPublicRevealSafety(active: boolean, onExpire: () => void): void {
  useEffect(() => {
    if (!active) return;
    const timer = window.setTimeout(onExpire, PRO_PUBLIC_REVEAL_MAX_MS);
    return () => clearTimeout(timer);
  }, [active, onExpire]);
}
